import {useState, FormEvent} from 'react';
import {Customer, PRODUCT_STATUS, ProductInstance} from '../../util/types';
import {addressShortened, translateCustomerStatus} from "../../util/formatter";
import {useNavigate} from "react-router-dom";
import Routing from "../../Routing.ts";

export const HIDE_RELATED_CUSTOMER_HINT = 'HIDE_RELATED_CUSTOMER_HINT/v1'

export default function RelatedCustomers(props: { relatedCustomers: Customer[], onSelect: (customer: Customer) => void, customer: Customer }) {
    const pickableCustomers = props.relatedCustomers
    const navigate = useNavigate()
    const [showPopUp, setShowPopUp] = useState(
        localStorage.getItem(HIDE_RELATED_CUSTOMER_HINT) === null
        || localStorage.getItem(HIDE_RELATED_CUSTOMER_HINT) === 'false'
    );

    const close = (event: FormEvent<HTMLFormElement>) => {
        const rememberDecision: boolean = (event.currentTarget.elements.namedItem('remember-decision') as HTMLInputElement).checked
        localStorage.setItem(HIDE_RELATED_CUSTOMER_HINT, String(rememberDecision))
        setShowPopUp(false);
    };

    function changeCustomer(customer: Customer) {
        if (props.customer.customer_id !== customer.customer_id) {
            props.onSelect(customer);
            navigate(Routing.Selfcare.Index)
        }
    }

    if (props.relatedCustomers.length === 1) {
        return <div className="selfcare-header-address single">
            <span>{addressShortened(props.customer.customer_contact)}</span>
            <span><CustomerInfo customer={props.customer}/></span>
        </div>
    }

    return (
        <>
        <div className={`selfcare-header-address multiple ${showPopUp ? 'no-hover' : ''}`}>
            <span className="text">
                <span>{addressShortened(props.customer.customer_contact)}</span>
                <span><CustomerInfo customer={props.customer}/></span>
            </span>
            <span className="dropdown-icon"></span>
            <div className="dropdown">
                <ul>
                    {pickableCustomers.sort((a, b) => {
                        if (addressShortened(a.customer_contact) < addressShortened(b.customer_contact)) {
                            return -1;
                        }
                        if (addressShortened(a.customer_contact) > addressShortened(b.customer_contact)) {
                            return 1;
                        }
                        return 0;
                    }).map((customer, index) => {

                        const product_instances = customer.product_instances.filter(
                            (product_instance: ProductInstance) =>
                                [PRODUCT_STATUS.ACTIVE, PRODUCT_STATUS.PENDING].includes(product_instance.product_instance_status) &&
                                product_instance.product.product_attribute_main
                        );

                        return (
                            <li key={index} className={props.customer.customer_id === customer.customer_id ? 'active' : ''}>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault()
                                        changeCustomer(customer)
                                    }}
                                >
                                    <span className="text">
                                        <span>{addressShortened(customer.customer_contact)}</span>
                                        <span><CustomerInfo customer={customer}/></span>
                                        {product_instances.map((product_instance: ProductInstance) => (
                                            <span key={product_instance.product_instance_id}>
                                                {product_instance.product.product_display_name}
                                            </span>
                                        ))}
                                    </span>
                                </button>
                            </li>
                        )
                    })}
                </ul>
            </div>
            {showPopUp && <MultipleAddressesHint onSubmit={close}/>}
        </div>
            {showPopUp && <div className={'pop-up-backdrop'}/>}
        </>
    )
}

function MultipleAddressesHint(props: { onSubmit: (event: FormEvent<HTMLFormElement>) => void }) {
    return <>
        <span className='pop-up-arrow multiple-addresses-hint'/>
        <dialog className='pop-up multiple-addresses-hint' open>
            <form method="dialog" onSubmit={props.onSubmit}>
                <p>
                    <strong>Her kan du skifte mellem dine profiler</strong>
                    <span>
                        Ændringer på denne profil bærer ikke over til andre profiler.
                        Hvis f.eks. dit betalingskort udløber, skal du huske at opdatere det på alle dine profiler.
                    </span>
                </p>
                <p className='with-checkbox'>
                    <input type="checkbox" id="remember-decision" name='remember-decision'/>
                    <label className="checkbox-label checkbox-label--montserrat" htmlFor="remember-decision">
                        Vis ikke igen
                    </label>
                </p>
                <button type={"submit"}>OK, det er forstået.</button>
            </form>
        </dialog>
    </>
}

function CustomerInfo (props: {customer : Customer}) {
    const status = props.customer.customer_context.customer_status;

    return (<>
        {['CANCEL', 'ORDER_DOWN', 'FINISH'].includes(status) && <>
            <strong>{translateCustomerStatus(status)}</strong>{' | '}
        </>}
        Kundenummer: {props.customer.customer_id}
    </>)
}
